import { memo } from 'react';
import { ethers } from 'ethers';
import BearHoney from './bearHoney';
import BeeHoney from './beeHoney';
import Hives from './hives';
import HoneyCombs from './honeyCombs';
import MigrateBear from './migrateBear';
import VXClaim from './vxClaim';

interface HoneyComponentProps {
  signer?: ethers.Signer;
  address?: string;
}

export const MemoizedBearHoney = memo<HoneyComponentProps>(BearHoney, (prevProps, nextProps) => {
  return prevProps.signer === nextProps.signer && 
         prevProps.address === nextProps.address;
});

export const MemoizedBeeHoney = memo<HoneyComponentProps>(BeeHoney, (prevProps, nextProps) => {
  return prevProps.signer === nextProps.signer && 
         prevProps.address === nextProps.address;
});

export const MemoizedHives = memo<HoneyComponentProps>(Hives, (prevProps, nextProps) => {
  return prevProps.signer === nextProps.signer && 
         prevProps.address === nextProps.address;
});

export const MemoizedHoneycombs = memo<HoneyComponentProps>(HoneyCombs, (prevProps, nextProps) => {
  return prevProps.signer === nextProps.signer && 
         prevProps.address === nextProps.address;
});

export const MemoizedMigrateBear = memo<HoneyComponentProps>(MigrateBear, (prevProps, nextProps) => {
  return prevProps.signer === nextProps.signer && 
         prevProps.address === nextProps.address;
});

export const MemoizedVXClaim = memo<HoneyComponentProps>(VXClaim, (prevProps, nextProps) => {
  return prevProps.signer === nextProps.signer && 
         prevProps.address === nextProps.address;
});